import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/authentication/Login'
import Register from '../views/authentication/Register'
import Profil from '../views/utilisateur/profil'
import UtilisateurInformations from '../views/utilisateur/utilisateur-informations'
import UtilisateurSoldes from '../views/utilisateur/utilisateur-soldes'
import Employe from '../views/employe/employe'
import EmployeDetail from '../views/employe/employe-detail'
import CongesSoldeDetail from '../components/conges/solde/conges-solde-detail'
import DetailSoldeDeRecuperation from '../components/employe/soldeDeRecuperation/detail-solde-de-recuperation.vue'
import EmployeDetailContrat from '../views/employe/contrat/employe-detail-contrat'
import EmployeCreate from '../views/employe/employe-create'
import EtablissementPage from '../views/etablissement/etablissement'
import AssociationPage from '../views/etablissement/association'
import AssociationDetail from '../views/etablissement/association-detail'
import EtablissementDetail from '../views/etablissement/etablissement-detail.vue'
import EtablissementTableauConges from '../views/etablissement/etablissement-tableau-conges'
import ServicePage from '../views/service/service'
import ServiceDetail from '../views/service/service-detail'
import ServicePlanning from '../views/service/service-planning'
import ModelePlanning from '../views/modele-planning/modele-planning'
import Planning from '../views/planning/planning'
import FicheAim from '@/views/ficheAIM/fiche-aim.vue'
import ServiceVirtuelPlanning from '../views/service/service-virtuel-planning.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/profil',
      name: 'profil',
      component: Profil,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'informations',
          name: 'utilisateur-informations',
          component: UtilisateurInformations,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'soldes',
          name: 'utilisateur-soldes',
          component: UtilisateurSoldes,
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: 'employe/:employeId/conges/:congesTypeId',
              name: 'UtilisateurDetailsCongesSolde',
              component: CongesSoldeDetail,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'employe/:employeId/recuperation',
              name: 'UtilisateurDetailsRecuperation',
              component: DetailSoldeDeRecuperation,
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/demande',
      name: 'demande',
      meta: {
        requiresAuth: true,
        redirectToNew: true,
      },
      children: [
        {
          path: ':demandeId/conges',
          name: 'demandeCongesDetail',
          meta: {
            requiresAuth: true,
            redirectToNew: true,
          },
        },
      ],
    },
    {
      path: '/tableau-des-conges',
      name: 'EtablissementTableauConges',
      component: EtablissementTableauConges,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/employes',
      name: 'employes',
      component: Employe,
      meta: {
        requiresAuth: true,
        permission: 'ADMINISTRATEUR',
      },
      children: [
        {
          path: 'create',
          name: 'employeCreate',
          component: EmployeCreate,
          meta: {
            requiresAuth: true,
            permission: 'ADMINISTRATEUR',
          },
        },
        {
          path: ':employeId',
          name: 'employe',
          component: EmployeDetail,
          meta: {
            requiresAuth: true,
            permission: 'ADMINISTRATEUR',
          },
          children: [
            {
              path: 'conges/:congesTypeId',
              name: 'EmployeDetailsCongesSolde',
              component: CongesSoldeDetail,
              meta: {
                requiresAuth: true,
                permission: 'ADMINISTRATEUR',
              },
            },
            {
              path: 'recuperation',
              name: 'RecuperationDetails',
              component: DetailSoldeDeRecuperation,
              meta: {
                requiresAuth: true,
                permission: 'ADMINISTRATEUR',
              },
            },
            {
              path: 'contrat',
              name: 'EmployeDetailContrat',
              component: EmployeDetailContrat,
              meta: {
                requiresAuth: true,
                permission: 'ADMINISTRATEUR',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/services',
      name: 'services',
      component: ServicePage,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: ':serviceId',
          name: 'service',
          component: ServiceDetail,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/etablissement',
      name: 'etablissement',
      component: EtablissementDetail,
      meta: {
        requiresAuth: true,
        permission: 'SALARIE',
      },
      children: [
        {
          path: '/etablissement/astreintes',
          name: 'etablissementAstreintes',
          component: EtablissementDetail,
          meta: {
            requiresAuth: true,
            permission: 'SALARIE',
            tabIndex: 0,
          },
        },
        {
          path: '/etablissement/restauration',
          name: 'etablissementRestauration',
          component: EtablissementDetail,
          meta: {
            requiresAuth: true,
            permission: 'SALARIE',
            tabIndex: 1,
          },
        },
        {
          path: '/etablissement/administration',
          name: 'etablissementAdministration',
          component: EtablissementDetail,
          meta: {
            requiresAuth: true,
            permission: 'SALARIE',
            tabIndex: 2,
          },
        },
      ],
    },
    // {
    //   path: '/comptabilite',
    //   name: 'comptabilite',
    //   component: Comptabilite,
    //   meta: {
    //     requiresAuth: true,
    //     permission: 'COMPTABLE',
    // authorizedEtablissements: process.env.VUE_APP_ETABLISSEMENTS_DU.split(':'),
    //   },
    //   children: [
    //     {
    //       path: 'usagers',
    //       name: 'comptabilite-usager',
    //       component: comptabiliteUsagers,
    //       meta: {
    //         requiresAuth: true,
    //         permission: 'COMPTABLE',
    // authorizedEtablissements: process.env.VUE_APP_ETABLISSEMENTS_DU.split(':'),
    //       },
    //       children: [
    //         {
    //           path: 'aim',
    //           name: 'comptabilite-usager-aim',
    //           component: comptabiliteUsagers,
    //           meta: {
    //             permission: 'COMPTABLE',
    // authorizedEtablissements: process.env.VUE_APP_ETABLISSEMENTS_DU.split(':'),
    //           },
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      path: '/etablissements',
      name: 'etablissements',
      component: EtablissementPage,
      meta: {
        requiresAuth: true,
        permission: 'Administrateur',
      },
      children: [
        {
          path: ':etablissementId',
          name: 'etablissement',
          component: EtablissementDetail,
          meta: {
            requiresAuth: true,
            permission: 'Administrateur',
          },
        },
      ],
    },
    {
      path: '/association',
      name: 'associations',
      component: AssociationPage,
      meta: {
        requiresAuth: true,
        permission: 'Administrateur',
      },
      children: [
        {
          path: ':associationId',
          name: 'association',
          component: AssociationDetail,
          meta: {
            requiresAuth: true,
            permission: 'Administrateur',
          },
        },
      ],
    },
    {
      path: '/services/:serviceId/modelePlanning',
      name: 'modelePlanning',
      component: ModelePlanning,
      meta: {
        requiresAuth: true,
        permission: 'SALARIE',
      },
    },
    {
      path: '/services/:serviceId/planning/:numeroSemaine?',
      name: 'service-planning',
      component: ServicePlanning,
      meta: {
        requiresAuth: true,
        permission: 'SALARIE',
      },
    },
    {
      path: '/services-virtuels/:serviceId/planning/:numeroSemaine?',
      name: 'service-virtuel-planning',
      component: ServiceVirtuelPlanning,
      meta: {
        requiresAuth: true,
        permission: 'SALARIE',
      },
    },
    {
      path: '/planning',
      name: 'planningUtilisateur',
      component: Planning,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        requiresAuth: true,
        permission: 'Administrateur',
      },
    },
    {
      path: '/fiche-aim/:ficheAimId',
      name: 'fiche-aim',
      component: FicheAim,
      meta: {
        requiresAuth: true,
        permission: 'SALARIE',
        authorizedEtablissements: process.env.VUE_APP_ETABLISSEMENTS_DU.split(':'),
      },
    },
    {
      path: '/usagers',
      name: 'usagers',
      meta: {
        redirectToNew: true,
      },
      children: [
        {
          path: ':usagerId',
          name: 'usager',
          meta: {
            redirectToNew: true,
          },
          children: [
            {
              path: 'finances-usager',
              name: 'finances-usager',
              meta: {
                redirectToNew: true,
              },
            },
          ],
        },
      ],
    },
  ],
})

function getNewFrontUrl() {
  if (process.env.VUE_APP_ENV_NAME !== 'dev') {
    return process.env.VUE_APP_URL
  } else {
    return process.env.VUE_APP_NEW_FRONT_ADRESS
  }
}

function redirectToNewFrontIfNeeded(to) {
  if (to.meta.redirectToNew) {
    window.open(getNewFrontUrl() + to.fullPath, '_self')
  }
}

router.beforeResolve((to, from, next) => {
  redirectToNewFrontIfNeeded(to, next)
  next()
})

router.beforeEach((to, from, next) => {
  const auth = JSON.parse(localStorage.getItem('auth'))
  let loggedIn = null
  if (auth && auth.authenticationResponse) {
    loggedIn = auth.authenticationResponse
  }

  const selectedEtablissementLocalStorage = JSON.parse(localStorage.getItem('selectedEtablissement'))
  let selectedEtablissement = null
  if (selectedEtablissementLocalStorage && selectedEtablissementLocalStorage.etablissement) {
    selectedEtablissement = selectedEtablissementLocalStorage.etablissement
  }

  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({
      name: 'login',
      query: {
        nextUrl: to.fullPath,
      },
    })
  } else {
    if (
      //La route requiert des permissions ET l'utilisateur n'a pas le bon rôle ET l'utilisateur n'a pas le rôle d'administrateur
      (to.matched.some((record) => record.meta.permission) &&
        !loggedIn.roles.includes('ROLE_' + to.meta.permission) &&
        !loggedIn.roles.includes(
          'ROLE_' + to.meta.permission + '_' + (selectedEtablissement ? selectedEtablissement.etablissementId : '')
        ) &&
        !loggedIn.roles.includes(
          'ROLE_' + to.meta.permission + '_' + (selectedEtablissement ? selectedEtablissement.siegeSocialId : '')
        ) &&
        !loggedIn.roles.includes('ROLE_Administrateur')) ||
      //OU la route demandée est celle du login
      to.fullPath === '/'
    ) {
      next('/planning')
    } else if (
      to.meta.usernames &&
      !to.meta.usernames.includes(loggedIn.username) &&
      !loggedIn.roles.includes('ROLE_Administrateur')
    ) {
      next('/planning')
    } else if (
      to.meta.authorizedEtablissements &&
      selectedEtablissement &&
      !to.meta.authorizedEtablissements.includes(selectedEtablissement.etablissementId.toString()) &&
      !loggedIn.roles.includes('ROLE_Administrateur')
    ) {
      next('/planning')
    } else {
      next()
    }
  }
})

export default router
